import { useState } from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { BellRinging, PaperPlaneTilt, CheckCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Th, Td, Empty, Tag, SectionTitle } from "@/components/common";
import { api, money, fmtDate, fmtDateTime, errMsg } from "@/lib/api";

const KIND = { check: "Çek", promissory: "Senet" };

export default function NoteReminders({ notes, total, onSent }) {
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);
  const sendable = notes.filter((n) => n.direction === "received" && n.email);
  const allSel = sendable.length > 0 && sel.length === sendable.length;
  const send = async (ids) => {
    setBusy(true);
    try {
      const { data } = await api.post("/reminders/notes/send", { ids });
      if (data.sent.length) toast.success(`${data.sent.length} çek/senet hatırlatması gönderildi`);
      data.failed.forEach((f) => toast.error(`${f.no || f.id}: ${f.reason}`));
      setSel([]);
      onSent();
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };
  const stage = (n) => n.days > 0 ? ["bg-red-100 text-red-700", `${n.days} gün geçti`] : n.days === 0 ? ["bg-amber-100 text-amber-800", "Vadesi bugün"] : ["bg-sky-100 text-sky-800", `${-n.days} gün kaldı`];

  return (
    <div className="mt-10" data-testid="note-reminders">
      <div className="flex flex-wrap items-center gap-3">
        <SectionTitle sub={`7 gün içinde vadesi gelen veya geçen portföy evrakı · ${money(total)}`}>Çek / Senet Vadeleri</SectionTitle>
        {sel.length > 0 && <Button onClick={() => send(sel)} disabled={busy} className="rounded-[4px] bg-teal-700 hover:bg-teal-800" data-testid="note-reminders-send-selected-button"><PaperPlaneTilt /> Seçilenlere Gönder ({sel.length})</Button>}
      </div>
      <div className="panel overflow-x-auto">
        <table className="w-full min-w-[820px]">
          <thead>
            <tr>
              <Th><input type="checkbox" checked={allSel} onChange={() => setSel(allSel ? [] : sendable.map((n) => n.id))} className="h-4 w-4 accent-teal-700" data-testid="note-reminders-select-all" /></Th>
              <Th>No</Th><Th>Tür</Th><Th>Yön</Th><Th>Cari</Th><Th>Vade</Th><Th>Durum</Th><Th right>Tutar</Th><Th>E-posta</Th><Th>Son Gönderim</Th><Th />
            </tr>
          </thead>
          <tbody>
            {notes.length === 0 && <Empty cols={11} text="Yaklaşan çek/senet vadesi yok" />}
            {notes.map((n) => {
              const [cls, label] = stage(n);
              const can = n.direction === "received" && n.email;
              return (
                <tr key={n.id} className="hover:bg-muted/50" data-testid={`note-reminder-row-${n.no}`}>
                  <Td><input type="checkbox" disabled={!can} checked={sel.includes(n.id)} className="h-4 w-4 accent-teal-700" onChange={() => setSel((s) => (s.includes(n.id) ? s.filter((x) => x !== n.id) : [...s, n.id]))} data-testid={`note-reminder-select-${n.no}`} /></Td>
                  <Td><Link to="/cek-senet" className="font-num hover:underline">{n.no}</Link></Td>
                  <Td>{KIND[n.kind]}</Td>
                  <Td><Tag tone={n.direction === "received" ? "sale" : "purchase"}>{n.direction === "received" ? "Alınan" : "Verilen"}</Tag></Td>
                  <Td>{n.account_name}</Td>
                  <Td className="font-num whitespace-nowrap">{fmtDate(n.due_date)}</Td>
                  <Td><span className={`inline-block whitespace-nowrap px-2 py-0.5 text-[11px] font-semibold ${cls}`}>{label}</span></Td>
                  <Td right>{money(n.amount)}</Td>
                  <Td className="text-xs">{n.direction === "issued" ? <span className="text-muted-foreground">bize ait ödeme</span> : n.email || <span className="text-red-600">tanımlı değil</span>}</Td>
                  <Td className="text-xs text-muted-foreground">{n.reminded_at ? <span className="inline-flex items-center gap-1 text-teal-700"><CheckCircle size={14} weight="fill" /> {fmtDateTime(n.reminded_at)}</span> : "—"}</Td>
                  <Td>{n.direction === "received" && <Button size="sm" variant="outline" disabled={!can || busy} className="rounded-[4px]" onClick={() => send([n.id])} data-testid={`note-reminder-send-${n.no}`}><BellRinging size={14} /> Hatırlat</Button>}</Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
